import moment from 'moment';

export const formatEstimatedTime = (durationInSeconds: number | null): string => {
    if (!durationInSeconds) {
        // fallback in case of some problem. Better show something.
        return '30 minutes';
    }

    const duration = moment.duration(durationInSeconds, 'seconds');

    // Get the whole minutes and remaining seconds.
    // NOTE: `duration.minutes()` is the minutes COMPONENT of the duration (0-59), so an hour comes
    // back as 0 and every estimate of an hour or more collapsed to the "1 minute" floor below.
    let minutes = Math.floor(duration.asMinutes());
    const remainingSeconds = duration.seconds();

    // Apply the rounding logic
    if (remainingSeconds >= 15) {
        minutes += 1;
    }

    // Ensure a minimum of 1 minute
    if (minutes < 1) {
        minutes = 1;
    }

    return `${minutes} minute${minutes > 1 ? 's' : ''}`;
};
